export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SummaryFilter.vue?vue&type=template&id=1f7e5410&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/summary/SummaryFilter.vue?vue&type=template&id=1f7e5410&scoped=true&
// module id = 1556
// module chunks = 0